// contexts/illustrations/components/BookLibrary/index.ts

export { IllustrationLibrary } from './BookLibrary';

// Subcomponents (for advanced usage)
export { LibraryFilters } from './components/LibraryFilters';
export { EmptyLibrary } from './components/EmptyLibrary';

// Hooks
export { useIllustrationLibrary } from './hooks/useBookLibrary';
